import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import banner1 from "../assets/carrossel-teste-2800x800.jpg";
import banner2 from "../assets/carrossel-teste-2800x800-slide2.jpg";
import config from "../config";
import { toast } from "react-toastify";

// Mudei o nome para heroImagesStatic para não conflitar com o estado
const heroImagesStatic = [banner1, banner2];

const MainContent = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [heroImages, setHeroImages] = useState(heroImagesStatic); // inicializar com as imagens estáticas para garantir valor inicial

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.has("confirmarNewsletter")) {
      toast.success("Subscrição confirmada com sucesso!");
    }
  }, []);

  useEffect(() => {
    // só criar o intervalo se houver imagens carregadas
    if (heroImages.length === 0) return;

    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % heroImages.length);
    }, 6000);

    return () => clearInterval(interval);
  }, [heroImages]); // depende do array heroImages, roda quando imagens mudam

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % heroImages.length);
  };

  const prevSlide = () => {
    setCurrentIndex(
      (prevIndex) => (prevIndex - 1 + heroImages.length) % heroImages.length,
    );
  };

  const [search, setSearch] = useState("");
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedNews, setSelectedNews] = useState(null);

  useEffect(() => {
    const fetchNews = async () => {
      try {
        const response = await fetch(`${config.baseURL}/api/Noticias`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        });

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();
        setNews(data);

        // Hero Images
        const heroRes = await fetch(
          `${config.baseURL}/api/Carousel/mainContent`,
        );
        const heroData = await heroRes.json();
        const images = heroData.map(
          (item) => `${config.baseURL}/img/${item.caminhoImagem}`,
        );
        // setHeroImages(images);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchNews();
  }, []);

  const [showModal, setShowModal] = useState(false);
  const [email, setEmail] = useState("");

  const handleSubscribe = async () => {
    if (!email || !/\S+@\S+\.\S+/.test(email)) {
      toast.error("Por favor, insira um e-mail válido.");
      return;
    }

    try {
      const response = await fetch(
        `${config.baseURL}/api/DestinatariosNewsletter`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(email),
        },
      );

      if (response.ok) {
        toast.success("Inscrição feita com sucesso!");
        setEmail("");
        setShowModal(false);
      } else {
        const errorData = await response.json();
        toast.error(
          errorData?.message || "Erro ao inscrever. Tente novamente.",
        );
      }
    } catch (error) {
      toast.error("Erro de rede. Verifique sua conexão.");
    }
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString("pt-BR");
  };

  return (
    <main className="">
      {/* Hero Section */}
      <section className="relative w-full aspect-[7/2] overflow-hidden">
        <div
          className="absolute top-0 left-0 right-0 bottom-0 bg-cover bg-center transition-opacity duration-1000"
          style={{ backgroundImage: `url(${heroImages[currentIndex]})` }}
        />
        <button
          onClick={prevSlide}
          className="absolute left-4 top-1/2 transform -translate-y-1/2 bg-black text-white p-2 z-10 rounded-full"
        >
          ❮
        </button>
        <button
          onClick={nextSlide}
          className="absolute right-4 top-1/2 transform -translate-y-1/2 bg-black text-white p-2 z-10 rounded-full"
        >
          ❯
        </button>
      </section>

      {/* News Section */}
      <div className="mt-[100px] mb-10 text-center">
        <h1 className="text-3xl font-semibold mb-6">NOTÍCIAS</h1>
        <h3 className="text-2xl font-semibold text-orange-600 mb-6">
          ÚLTIMAS NOVIDADES DA SCMT
        </h3>
      </div>
      <div className="w-[70%] mx-auto my-[100px] grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {news.length > 0
          ? news
              .sort(
                (a, b) =>
                  new Date(b.dataPublicacao).getTime() -
                  new Date(a.dataPublicacao).getTime(),
              )
              .slice(0, 3)
              .map((item) => (
                <div className="bg-white p-4 rounded-lg shadow-md flex flex-col h-full">
                  <img
                    src={`${config.baseURL}/files/${item.caminhoImagem}`}
                    alt={item.titulo}
                    className="w-full aspect-[2/1] object-cover rounded-md mb-2"
                  />
                  <p className="text-sm text-gray-500">
                    {formatDate(item.dataPublicacao)}
                  </p>
                  <h3 className="font-semibold text-xl mt-2">{item.titulo}</h3>

                  {/* Resumo com altura limitada e overflow scrollável */}
                  <p className="text-gray-700 mt-2 flex-grow overflow-hidden h-24">
                    {item.resumo}
                  </p>

                  {/* Link com o botão */}
                  <div className="mt-4">
                    <Link to={`/Noticias/${item.id}`}>
                      <button className="text-white bg-orange-600 hover:bg-orange-700 py-4 px-6 rounded-full text-sm flex items-center justify-center">
                        Ver Notícia
                      </button>
                    </Link>
                  </div>
                </div>
              ))
          : !loading && (
              <p className="text-center col-span-full">
                Nenhuma notícia encontrada.
              </p>
            )}
      </div>

      {/* Newsletter Section */}
      <section className="bg-gray-100 py-12 mt-10 mb-[50px]">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-3xl font-semibold mb-4">NEWSLETTER</h2>
          <p className="text-lg text-gray-600 mb-4">
            Subscreva a nossa newsletter e fique a par das últimas notícias,
            projetos e iniciativas da Santa Casa da Misericórdia de Tomar.
          </p>
          <p className="text-lg text-gray-600 mb-6">
            Acompanhe o nosso trabalho na comunidade e receba informações sobre
            eventos, serviços e formas de apoio diretamente no seu e-mail.
          </p>
          <button
            className="text-white bg-black py-2 px-6 rounded-lg"
            onClick={() => setShowModal(true)}
          >
            SUBSCREVER
          </button>
        </div>
      </section>

      {/* Modal */}
      {showModal && (
        <div
          className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 flex justify-center items-center z-50"
          onClick={() => setShowModal(false)}
        >
          <div
            className="bg-white p-6 rounded-lg w-full sm:w-96 text-center"
            onClick={(e) => e.stopPropagation()}
          >
            <h3 className="text-xl font-semibold mb-4">Insira o seu e-mail</h3>
            <input
              type="email"
              placeholder="seuemail@exemplo.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full p-3 border border-gray-300 rounded-md mb-4"
            />
            <button
              className={`${
                !email || !/\S+@\S+\.\S+/.test(email)
                  ? "bg-gray-400 cursor-not-allowed"
                  : "bg-black hover:bg-gray-800"
              } text-white py-2 px-4 rounded-lg transition`}
              onClick={handleSubscribe}
              disabled={!email || !/\S+@\S+\.\S+/.test(email)}
            >
              Enviar
            </button>
          </div>
        </div>
      )}
    </main>
  );
};

export default MainContent;
